export const enum SupportChatOrderSummaryStatus {
    EmailNotVerified = 0,
    NothingFound = 1,
    PaidOnly = 2,
    PaidAndFailedAttempts = 3,
    FailedAttemptsOnly = 4,
    PendingTransfer = 5,
    NeedsManualCheck = 6,
    PaidSeveralEvents = 7
}
